var map = {
	"./alt-farbig/arm-left-back.png": "a2e6",
	"./alt-farbig/arm-left-front.png": "9a44",
	"./alt-farbig/arm-right-back.png": "0e4f",
	"./alt-farbig/arm-right-front.png": "e178",
	"./alt-farbig/beine-seite-outline-L.png": "8921",
	"./alt-farbig/beine-seite-outline-R.png": "b931",
	"./alt-farbig/boy-body-back.png": "7de0",
	"./alt-farbig/boy-body-front.png": "d8f1",
	"./alt-farbig/boy-head-back.png": "11ac",
	"./alt-farbig/boy-head-front.png": "2b05",
	"./alt-farbig/boy-torso-back.png": "77a2",
	"./alt-farbig/boy-torso-front.png": "869b",
	"./alt-farbig/foot-left-back.png": "c2cd",
	"./alt-farbig/foot-left-top.png": "7635",
	"./alt-farbig/foot-right-back.png": "c322",
	"./alt-farbig/foot-right-top.png": "4bf6",
	"./alt-farbig/girl-body-back.png": "54d5",
	"./alt-farbig/girl-body-front.png": "889b",
	"./alt-farbig/girl-head-back.png": "38ff",
	"./alt-farbig/girl-head-front.png": "d4ec",
	"./alt-farbig/girl-torso-back.png": "497a",
	"./alt-farbig/girl-torso-front.png": "f1c88",
	"./alt-farbig/hand-left-bottom.png": "9ae0",
	"./alt-farbig/hand-left-top.png": "be85",
	"./alt-farbig/hand-right-bottom.png": "6b8c",
	"./alt-farbig/hand-right-top.png": "7f4c",
	"./alt-farbig/leg-left-back.png": "6a56",
	"./alt-farbig/leg-left-front.png": "09df",
	"./alt-farbig/leg-right-back.png": "ece7",
	"./alt-farbig/leg-right-front.png": "a784",
	"./alt-farbig/man-body-back.png": "62e8",
	"./alt-farbig/man-body-front.png": "fb10",
	"./alt-farbig/man-head-back.png": "decc",
	"./alt-farbig/man-head-front.png": "b7b6",
	"./alt-farbig/man-mouth.png": "7ff2",
	"./alt-farbig/man-torso-back.png": "8008",
	"./alt-farbig/man-torso-front.png": "a139",
	"./alt-farbig/woman-body-back.png": "294d",
	"./alt-farbig/woman-body-front.png": "66f3",
	"./alt-farbig/woman-head-back.png": "ebb0",
	"./alt-farbig/woman-head-front.png": "397c",
	"./alt-farbig/woman-mouth.png": "80a1",
	"./alt-farbig/woman-torso-back.png": "3d6f",
	"./alt-farbig/woman-torso-front.png": "289c",
	"./alt/arm-left.png": "9fcf",
	"./alt/arm-right.png": "0b39",
	"./alt/hand-left-bottom.png": "9788",
	"./alt/hand-left-top.png": "864b",
	"./alt/hand-right-bottom.png": "47f5",
	"./alt/hand-right-top.png": "9ccb",
	"./alt/leg-left.png": "94c2",
	"./alt/leg-right.png": "7c7e",
	"./alt/man-front.png": "ede6",
	"./alt/man-head-front.png": "2d14",
	"./alt/man-torso-front.png": "a452",
	"./arm-back.png": "e83b",
	"./arm-front.png": "68bd",
	"./arm-left-back.png": "5990",
	"./arm-left-front.png": "fab0",
	"./arm-right-back.png": "8295",
	"./arm-right-front.png": "901d",
	"./foot-back.png": "0d8e",
	"./foot-left-back.png": "f305",
	"./foot-left-top.png": "a7c1",
	"./foot-right-back.png": "aaf7",
	"./foot-right-top.png": "31d7",
	"./foot-top.png": "8b04",
	"./hand-bottom.png": "5230",
	"./hand-left-bottom.png": "48c2",
	"./hand-left-top.png": "cf6c",
	"./hand-right-bottom.png": "6217",
	"./hand-right-top.png": "b75e",
	"./hand-top.png": "e54c",
	"./leg-back.png": "8cc8",
	"./leg-front.png": "bc08",
	"./leg-left-back.png": "48b5",
	"./leg-left-front.png": "e2c6",
	"./leg-right-back.png": "652a",
	"./leg-right-front.png": "0fac",
	"./man-body-back.png": "5fe1",
	"./man-body-front.png": "5a73",
	"./man-body-upper-back.png": "c5ea",
	"./man-body-upper-front.png": "2406",
	"./man-head-back.png": "7def",
	"./man-head-front.png": "ecc4",
	"./man-mouth.png": "92bc",
	"./man-torso-back.png": "5704",
	"./man-torso-front.png": "705b",
	"./not-used/leg-left-side.png": "8bf6",
	"./not-used/leg-right-side.png": "97e1",
	"./outline/arm-left-back.png": "686b",
	"./outline/arm-left-front.png": "f40c",
	"./outline/arm-right-back.png": "f017",
	"./outline/arm-right-front.png": "0baf",
	"./outline/boy-body-back.png": "cd19",
	"./outline/boy-body-front.png": "4911",
	"./outline/boy-head-back.png": "5da0",
	"./outline/boy-head-front.png": "2628",
	"./outline/boy-torso-back.png": "0c09",
	"./outline/boy-torso-front.png": "fed5",
	"./outline/foot-left-back.png": "cc28",
	"./outline/foot-left-top.png": "1ed3",
	"./outline/foot-right-back.png": "08dc",
	"./outline/foot-right-top.png": "99b7",
	"./outline/girl-body-back.png": "7b2f",
	"./outline/girl-body-front.png": "b74d",
	"./outline/girl-head-back.png": "c73a",
	"./outline/girl-head-front.png": "d4c4",
	"./outline/girl-torso-back.png": "c3e0",
	"./outline/girl-torso-front.png": "3877",
	"./outline/hand-left-bottom.png": "c6d3",
	"./outline/hand-left-top.png": "5b49",
	"./outline/hand-right-bottom.png": "da79",
	"./outline/hand-right-top.png": "9d70",
	"./outline/leg-left-back.png": "9726",
	"./outline/leg-left-front.png": "5140",
	"./outline/leg-right-back.png": "175b",
	"./outline/leg-right-front.png": "e570",
	"./outline/man-body-back.png": "7d8b",
	"./outline/man-body-front.png": "6701",
	"./outline/man-head-back.png": "f0f8",
	"./outline/man-head-front.png": "1ab3",
	"./outline/man-torso-back.png": "4202",
	"./outline/man-torso-front.png": "c8b0",
	"./outline/woman-body-back.png": "e8e6",
	"./outline/woman-body-front.png": "bee1",
	"./outline/woman-head-back.png": "50df",
	"./outline/woman-head-front.png": "b87d",
	"./outline/woman-torso-back.png": "b80e",
	"./outline/woman-torso-front.png": "60e7",
	"./woman-arm-back.png": "dad9",
	"./woman-arm-front.png": "9a67",
	"./woman-body-back.png": "295a",
	"./woman-body-front.png": "372c",
	"./woman-body-upper-back.png": "0b2f",
	"./woman-body-upper-front.png": "3fb6",
	"./woman-head-back.png": "f410",
	"./woman-head-front.png": "4407",
	"./woman-leg-back.png": "fc18",
	"./woman-leg-front.png": "ba3e",
	"./woman-mouth.png": "8cb6",
	"./woman-torso-back.png": "ad0d",
	"./woman-torso-front.png": "bfb8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3ef1";